var React = require('react');

function HighlightRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"rgb(246, 169, 207)","strokeWidth":"4","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M9.886 2.375L2.703 5.897M2.81 17.63L10 21.137M13 11.63H4"})));
}

HighlightRight.defaultProps = {"width":"15","height":"24"};

module.exports = HighlightRight;

HighlightRight.default = HighlightRight;
